<div
  class="pnl-coupons"
  [class.open]="open"
  infiniteScroll
  [fromRoot]="true"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="20"
  [infiniteScrollContainer]="selector"
  (scrolled)="onScroll()"
>
  <header>
    <h1>Cupons de descontos</h1>
    <a [routerLink]="['/app/descontos/cupom']">Gerar cupom</a>
  </header>
  <section class="pnl">
    <ul class="tabs">
      <li
        class="todos"
        (click)="changeTab('todos')"
        [class.active]="tab == 'todos'"
        class="dnone"
      >
        <a>
          <h4>{{ num_todos }}</h4>
          <strong>Todos</strong>
        </a>
      </li>
      <li
        class="ativo"
        (click)="changeTab('ativo')"
        [class.active]="tab == 'ativo'"
      >
        <a>
          <span>{{ num_ativo }}</span>
          <strong>Ativo</strong>
        </a>
      </li>
      <li
        class="agendado"
        (click)="changeTab('agendado')"
        [class.active]="tab == 'agendado'"
      >
        <a>
          <span>{{ num_agendado }}</span>
          <strong>Agendado</strong>
        </a>
      </li>
      <li
        class="expirado"
        (click)="changeTab('expirado')"
        [class.active]="tab == 'expirado'"
      >
        <a>
          <span>{{ num_expirado }}</span>
          <strong>Expirado</strong>
        </a>
      </li>
    </ul>
    <div
      class="coupons"
      [class.todos]="tab == 'todos'"
      [class.ativo]="tab == 'ativo'"
      [class.agendado]="tab == 'agendado'"
      [class.expirado]="tab == 'expirado'"
    >
      <div
        *ngFor="let c of coupons; let i = index"
        (click)="openDetail(c, i)"
        [class.active]="i == openid && c.idcupom == coupon.idcupom"
        class="coupon"
      >
        <div class="descricao">
          <strong>{{ c.codigo }}</strong>
          <span>{{ c.descricao }}</span>
        </div>
        <div class="aplicado">
          {{ c.aplicados }} {{ c.aplicados <= 1 ? "Aplicado" : "Aplicados" }}
        </div>
        <div class="status">
          <b *ngIf="c.ativo" class="ativo">Ativo</b>
          <b *ngIf="c.agendado" class="agendado">Agendado</b>
          <b *ngIf="c.expirado" class="expirado">Expirado</b>
        </div>
        <div class="data">
          {{ c.observacao }}
        </div>
      </div>
      <div class="coupons-loading" *ngIf="loadingCoupon && !loadingTab">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-loading" *ngIf="loadingTab">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </section>
  <aside id="detailCoupon" class="detail">
    <form [formGroup]="couponFrm" (ngSubmit)="onSubmit()" novalidate>
      <header *ngIf="!isDeleteCupom">
        <div class="action-status">
          <div class="ipt-switch">
            <input
              id="ckStatus"
              type="checkbox"
              (change)="updateStatus()"
              formControlName="status"
              name="status"
            />
            <label for="ckStatus"></label>
          </div>
          <span>Cupom {{ status.value ? "ativo" : "inativo" }}</span>
        </div>

        <a (click)="closeDetail()" class="btn-close"></a>
        <div
          class="btn-option"
          (click)="toggleOptions()"
          (mouseout)="hideOptions()"
          [class.open]="optionOpen"
        >
          <i></i>
          <i></i>
          <i></i>
          <div (mouseover)="clearOptions()" (mouseout)="hideOptions()">
            <a [routerLink]="['/app/descontos/cupom/' + coupon.idcupom]"
              >Editar cupom <i class="ic ic-pen"></i
            ></a>
            <a (click)="showURL()"
              >{{ this.showLink ? "Ocultar URL" : "Mostrar URL" }}
              <i class="ic ic-link"></i
            ></a>
            <a (click)="showDeleteCupom()"
              >Excluir cupom <i class="ic ic-delete"></i
            ></a>
          </div>
        </div>
      </header>

      <section *ngIf="!isDeleteCupom">
        <div class="transfer-copy" *ngIf="status.value && showLink">
          <div>
            {{ couponUrl }}
          </div>
          <a
            (click)="onCopy()"
            [cdkCopyToClipboard]="couponUrl"
            [class.copy]="isCopy"
            >{{ isCopy ? "COPIADO" : "COPIAR LINK" }}</a
          >
        </div>
        <div class="cupom" [class.oc30]="!status.value">
          <div class="descricao">
            <strong>{{ coupon.codigo }}</strong>
            <p>
              {{ requisitoCupom() }}<br />
              {{
                coupon.tipo_limite_cliente == "L"
                  ? coupon.limite_cliente + " cupom limitado por cliente"
                  : "cupom ilimitado por cliente"
              }}<br />
              Válido até
              {{
                coupon.flag_final == "D"
                  ? (coupon.dt_expiracao | date: "dd/MM/y")
                  : "a promoção acabar"
              }}
            </p>
          </div>
          <div class="right">
            <span>CUPOM DE DESCONTO</span>
          </div>
          <i class="ic ic-stamp">
            <small *ngIf="coupon.tipo_desconto == 'F'">R$</small>
            <span>{{ coupon.desconto | number: "1.0-2" }}</span>
            <small *ngIf="coupon.tipo_desconto == 'P'">%</small>
          </i>
        </div>
      </section>

      <section *ngIf="isDeleteCupom" class="detailCouponDelete">
        <i class="ic ic-ticket-delete"></i>
        <h3>Tem certeza que deseja excluir este cupom?</h3>
        <p>
          <strong>Não é aconselhável excluir cupons.</strong><br />
          Esteja ciente sobre a perda dos dados estatísticos.
        </p>
      </section>

      <section>
        <div class="relatorio">
          <strong> Relatório de atividades </strong>
          <div>
            <span>Cupons utilizados</span>
            <span
              >{{ coupon.aplicados
              }}{{
                coupon.tipo_limite_distribuidos == "L"
                  ? " de " + coupon.limite_distribuidos + " restantes"
                  : ""
              }}</span
            >
          </div>
          <div>
            <span>Criado em</span>
            <span *ngIf="coupon.dt_cadastro">{{
              coupon.dt_cadastro.replace(" ", "T") | date: "d/MM/y"
            }}</span>
          </div>
          <div>
            <span>Criado por</span>
            <span>{{ coupon.nome }}</span>
          </div>
        </div>
      </section>
    </form>
    <footer *ngIf="isDeleteCupom">
      <button (click)="onDeleteCupom()" class="btn btn-danger">
        Sim! Quero excluir
      </button>
      <button (click)="showDeleteCupom()" class="btn btn-primary-outline">
        Cancelar exclusão
      </button>
    </footer>

    <div *ngIf="showConfirmDelete" class="showConfirmDelete">
      <i class="ic ic-delete-confirm"></i>
      <strong>Excluído com sucesso</strong>
    </div>

    <div class="loading" *ngIf="loadingDetail!!; loadingDelete">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </aside>
</div>
